const commonRoutes = {
  default: "/deliveries/orders",
  login: "/welcome/login",
};

export default commonRoutes;
